/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authService: false,
    user: null,
    permission: null,
    farmStore: null,
    jobStore: null,
    mekaStore: null,
    namisInfo: null,
    config: {
      defaultDateFormat: 'DD/MM/YYYY'
    },
  },
  mutations: {
    authServiceReady (state) {
      if (!state.authService) state.authService = true
    },
    setUser (state, user) {
      state.user = user
    },
    setConfig (state, newValue) {
      state.config = newValue
    },
    setPermission (state, newValue) {
      state.permission = newValue
    },
    setScorecardChildrenID (state, newValue) {
      state.modules.KPI.scorecardChildrenID = newValue
    },
    setFarm (state, newValue) {
      state.farmStore = newValue
    },
    setMeka (state, newValue) {
      state.mekaStore = newValue
    },
    setJobs (state, newValue) {
      state.jobStore = newValue
    },
    setNamisInfo (state, newValue) {
      state.namisInfo = newValue
    },
  },
  actions: {
    registerUser ({ commit, state }, user) {
      commit('authServiceReady')
      commit('setUser', user)
    },
    registerPermission ({ commit, state }, permission) {
      commit('setPermission', permission)
    },
    registerFarm ({ commit, state }, farmStore) {
      commit('setFarm', farmStore)
    },
    registerJobs ({ commit, state }, jobStore) {
      commit('setJobs', jobStore)
    },
    registerMeka ({ commit, state }, mekaStore) {
      commit('setMeka', mekaStore)
    },
    registerNamisInfo ({ commit, state }, namisInfo) {
      commit('setNamisInfo', namisInfo)
    },
  },
  getters: {
    isAnonymous: state => {
      return state.authService && !state.user
    },
    user: state => {
      return state.user
    },
    permission: state => {
      return state.permission
    },
    farmStore: state => {
      return state.farmStore
    },
    mekaStore: state => {
      return state.mekaStore
    },
    jobStore: state => {
      return state.jobStore
    },
    namisInfo: state => {
      return state.namisInfo
    },
  }
})
